// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"77484026","455":"ace77a91","977":"7f97990d"}[chunkId] + ".chunk.js";
};